import { useState, useCallback } from 'react'
import { FormData, StepId } from '../types'

interface UseStepNavigationReturn {
  currentStepId: StepId
  stepHistory: StepId[]
  goToNextStep: (formData: Partial<FormData>) => void
}

export function useStepNavigation(): UseStepNavigationReturn {
  const [currentStepId, setCurrentStepId] = useState<StepId>('role')
  const [stepHistory, setStepHistory] = useState<StepId[]>(['role'])

  const getNextStepId = useCallback((currentStep: StepId, formData: Partial<FormData>): StepId => {
    switch (currentStep) {
      case 'role':
        // If Student/Learner, skip to discovery source
        if (formData.role === 'Student / Learner') {
          return 'discoverySource'
        }
        return 'useCase'

      case 'useCase':
        return 'companySize'

      case 'companySize':
        return 'discoverySource'

      case 'discoverySource':
        // If YouTube selected, show YouTube channel question
        if (formData.discoverySource === 'YouTube') {
          return 'youtubeChannel'
        }
        return 'completed'

      case 'youtubeChannel':
        return 'completed'

      case 'completed':
        return 'completed'

      default:
        return 'completed'
    }
  }, [])

  const goToNextStep = useCallback(
    (formData: Partial<FormData>) => {
      const nextStepId = getNextStepId(currentStepId, formData)
      setCurrentStepId(nextStepId)
      setStepHistory((prev) => [...prev, nextStepId])
    },
    [currentStepId, getNextStepId]
  )

  return {
    currentStepId,
    stepHistory,
    goToNextStep,
  }
}
